import React from "react";
import "./MobileFilter.scss";
import PropTypes from "prop-types";

const MobileFilter = ({ name, selectedCount, totalCount, onEdit }) => {
  const className = `mobile-filter ${
    name.toLowerCase() === "nib size" ? "mobile-filter--size" : ""
  }`;
  return (
    <div className={className}>
      <h6>{name}</h6>
      {selectedCount > 0 && (
        <span className="mobile-filter__selected-text">
          {selectedCount} of {totalCount} selected
        </span>
      )}
      {selectedCount === 0 && (
        <span className="mobile-filter__selected-text">
          All {name.toLowerCase()}s
        </span>
      )}
      <button className="mobile-filter__edit" onClick={onEdit}>
        Edit
      </button>
    </div>
  );
};

MobileFilter.defaultProps = {
  name: "No name",
  selectedCount: 0,
  totalCount: 0,
};

MobileFilter.propTypes = {
  name: PropTypes.string,
  selectedCount: PropTypes.number,
  totalCount: PropTypes.number,
  onEdit: PropTypes.func,
};

export default MobileFilter;
